"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarouselNav: function() {
        return _TeachingPopoverCarouselNav.TeachingPopoverCarouselNav;
    },
    renderTeachingPopoverCarouselNav_unstable: function() {
        return _renderTeachingPopoverCarouselNav.renderTeachingPopoverCarouselNav_unstable;
    },
    teachingPopoverCarouselNavClassNames: function() {
        return _useTeachingPopoverCarouselNavStylesstyles.teachingPopoverCarouselNavClassNames;
    },
    useTeachingPopoverCarouselNavStyles_unstable: function() {
        return _useTeachingPopoverCarouselNavStylesstyles.useTeachingPopoverCarouselNavStyles_unstable;
    },
    useTeachingPopoverCarouselNav_unstable: function() {
        return _useTeachingPopoverCarouselNav.useTeachingPopoverCarouselNav_unstable;
    }
});
const _TeachingPopoverCarouselNav = require("./TeachingPopoverCarouselNav");
const _renderTeachingPopoverCarouselNav = require("./renderTeachingPopoverCarouselNav");
const _useTeachingPopoverCarouselNav = require("./useTeachingPopoverCarouselNav");
const _useTeachingPopoverCarouselNavStylesstyles = require("./useTeachingPopoverCarouselNavStyles.styles");
